import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  makeStyles,
  Theme,
  createStyles,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from '../../../styles/_variables.module.scss';

const useDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      paddingBottom: 0,
    },
    icon: {
      cursor: 'pointer',
      userSelect: 'none',
      color: theme.palette.grey[500],
    },
    message: {
      fontWeight: Number(styles.semiBoldTextWeight),
      fontSize: '1.0625rem',
    },
    content: {
      padding: '2rem 3rem',
      paddingTop: '1rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
    actions: {
      marginTop: '1.4rem',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    okButton: {
      marginLeft: '1rem',
    },
  }),
);

interface EmailConfirmationDialogProps {
  open: boolean;
  setOpen(value: boolean): void;
  message: string;
  action(): void;
}

function EmailConfirmationDialog({ open, setOpen, message, action }: EmailConfirmationDialogProps) {
  const classes = useDialogStyles();

  const handleOk = () => {
    action();
  };

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Dialog className="dialog" open={open} onClose={closeDialog}>
      <DialogTitle className={classes.title}>
        <CloseIcon fontSize="default" className={classes.icon} onClick={closeDialog} />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.message}>{message}</Typography>
        <div className={classes.actions}>
          <Button onClick={closeDialog} variant="outlined" color="secondary">
            Revisar datos
          </Button>
          <Button
            form="businessForm"
            type="submit"
            color="primary"
            className={classes.okButton}
            variant="contained"
            onClick={handleOk}
          >
            Si, crear cuenta
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default EmailConfirmationDialog;
